import LoadingIndicator from "@/_old/layouts/loading-indicator/loading-indicator";
import { FunctionComponent } from "react";
import { useBoot } from "@/core/components/auth/hooks/useBoot";
import AuthInitProviders from "@/core/components/auth/view/init.provider";
import { PropsWithChildren } from "react";

export const AuthProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const { isAuthenticated, userInfo, isLoading } = useBoot();

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!isAuthenticated) {
    throw new Error("user not logged");
  }

  if (!userInfo) {
    throw new Error("user not found");
  }

  if (userInfo.profile?.verified_email === false) {
    throw new Error("user not verified");
  }

  return <AuthInitProviders userInfo={userInfo}>{children}</AuthInitProviders>;
};
